

















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { daolvCity, tuijianCity, getHotelList, adInfo } from '@/api/daolv'
import { formatDate } from '@/utils/tool'
import ProductSkeleton from './components/ProductSkeleton/index.vue'
import { HOTEL_INFO } from '@/api/daolv-api'

@Component({
  name: 'Hotel',
  components: {
    ProductSkeleton
  }
})
export default class Hotel extends Vue {
  private loading = true // 设置为true是为了先展示骨架屏
  private searchMuDi = '' // 目的地
  private searchCode = '' // 目的地CodeId
  private keyword = '' // 搜索关键字
  private startDay = formatDate(+new Date(), 'Y-M-D') // 用户选中的入住日期
  private endDay = formatDate(+new Date() + 24 * 60 * 60 * 1000, 'Y-M-D') // 用户选中的离店日期
  private startWeek = '' // 入住周期
  private endWeek = '' // 离店周期
  private readonly weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  private roomNum = 1 // 房间数量
  private adultNum = 1 // 成人数量
  private childNum = 0 // 儿童数量
  private carouselList = [] as Array<HOTEL_INFO> // 酒店轮播
  private tabCode = '' // tab选项卡 cityCode
  private tabCity = '' // tab 名称
  private tuiJianCity: any[] = [] // 精品推荐城市
  private hotListData = [] // 列表数据

  formatDate = formatDate

  @Watch('startDay')
  setStartDay (): void {
    if (+new Date(this.startDay) > +new Date(this.endDay)) {
      console.log('离店日期不可以小于入住日期', this.endDay)
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
    }
  }

  // @Watch('endDay')
  // setEndDay (newValue: Date): void {
  //   // console.log(newValue)
  //   if (+new Date(this.startDay) > +new Date(this.endDay)) {
  //     console.log('离店日期不可以小于入住日期', this.endDay)
  //     // this.$message({
  //     //   message: '离店日期不可以小于入住日期',
  //     //   type: 'warning'
  //     // })
  //     this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
  //     this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
  //   }
  // }

  // 入住日期改变事件
  changeStartDay (value: Date): void {
    // console.log(value, this.startDay)
    if (+new Date(value) < +new Date() - 24 * 60 * 60 * 1000) {
      console.log('入住日期不能小于当天日期', formatDate(+new Date(), 'Y-M-D'))
      this.$message({
        message: '入住日期不能小于当天日期',
        type: 'warning'
      })
      this.startDay = formatDate(+new Date(), 'Y-M-D')
      return
    }
    this.startDay = formatDate(+new Date(value), 'Y-M-D')
    this.startWeek = this.weekList[new Date(value).getDay()]
    if (+new Date(this.startDay) === +new Date(this.endDay)) {
      this.$message({
        message: '入住日期不能等于离店日期',
        type: 'warning'
      })
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
    }
    console.log(value, this.startDay, this.endDay)
  }

  // 离店日期改变事件
  changeEndDay (value: Date): void {
    // console.log(value, this.endDay)
    if (+new Date(this.startDay) > +new Date(this.endDay)) {
      console.log('离店日期不可以小于入住日期', this.endDay)
      this.$message({
        message: '离店日期不可以小于入住日期',
        type: 'warning'
      })
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
      return
    }
    this.endDay = formatDate(+new Date(value), 'Y-M-D')
    this.endWeek = this.weekList[+new Date(value).getDay()]
    console.log(value, this.endDay)
  }

  // api获取城市列表
  private getCity (callback) {
    daolvCity({
      cityName: this.searchMuDi
    }).then(res => {
      if (res && res.results && res.results.length) {
        this.searchCode = res.results[0].cityCode // 1、用户输入完城市没有手动选择城市 默认选中第一个
        callback(res.results)
      } else {
        this.searchCode = ''
      }
    }).catch(err => {
      console.error(err)
    })
  }

  // 目的地输入搜索
  querySearchAsync (queryString, cb) {
    this.searchMuDi = queryString
    this.getCity(cb)
  }

  // 选择的 cityCode 目的地
  private handleSelect (item) {
    console.log('handleSelect', item)
    this.searchCode = item.cityCode // 2、手动再更新城市
  }

  // 搜索事件触发
  clickSearch () {
    if (!this.searchMuDi) return this.$message.warning('请先选择城市')
    const queryParams = new URLSearchParams({
      searchMuDi: this.searchMuDi,
      searchCode: this.searchCode,
      keyword: this.keyword,
      startDate: this.startDay,
      endDate: this.endDay,
      startWeek: this.startWeek,
      endWeek: this.endWeek,
      roomNum: this.roomNum.toString(),
      adultNum: this.adultNum.toString(),
      childNum: this.childNum.toString()
    })
    const url = `${window.location.origin}/#/hotelList?${queryParams.toString()}`
    window.open(url)
  }

  // 轮播广告位
  gerAdInfo () {
    adInfo().then(res => {
      if ((res && res.hotelList) || res.success) {
        this.carouselList = res.hotelList || []
      } else {
        console.error(res.msg)
        this.$message.error(res.msg)
      }
    }).catch(err => {
      console.log(err)
    })
  }

  // 更多精品酒店
  moreHotel () {
    const queryParams = new URLSearchParams({
      searchMuDi: this.tabCity,
      searchCode: this.tabCode,
      keyword: this.keyword,
      startDate: this.startDay,
      endDate: this.endDay,
      startWeek: this.startWeek,
      endWeek: this.endWeek,
      roomNum: this.roomNum.toString(),
      adultNum: this.adultNum.toString(),
      childNum: this.childNum.toString()
    })
    const url = `${window.location.origin}/#/hotelList?${queryParams.toString()}`
    window.open(url)
  }

  // 跳转到酒店详情页面
  private goToDetail (item) {
    console.log(item)
    const queryParams = new URLSearchParams({
      hotelId: item.hotelId,
      startDate: this.startDay,
      endDate: this.endDay,
      startWeek: this.startWeek,
      endWeek: this.endWeek,
      roomNum: this.roomNum.toString(),
      adultNum: this.adultNum.toString(),
      childNum: this.childNum.toString()
    })
    const url = `${window.location.origin}/#/hotelDetail?${queryParams.toString()}`
    window.open(url)
  }

  // 切换tab选项卡
  private handleClick (tab, event) {
    console.log(tab, event)
    console.log(this.tabCode, tab.label, tab.name)
    this.tabCity = tab.label
    this.getHotelList()
  }

  // 获取精品推荐城市
  getTuijianCity () {
    tuijianCity().then(res => {
      if (res && res.results) {
        console.log('tuijianCity', res)
        this.tuiJianCity = res.results.splice(0, 10) || []
        this.tabCode = this.tuiJianCity[0].cityCode || ''
        this.tabCity = this.tuiJianCity[0].cityName || ''
        this.getHotelList() // 获取精品推荐城市数据
      }
    }).catch(err => {
      console.error(err)
    })
  }

  // 获取精品推荐城市数据
  getHotelList () {
    console.log(this.tabCode, this.tuiJianCity)
    this.loading = true
    const params = {
      cityCode: this.tabCode === '0' || null ? this.tuiJianCity[0].cityCode : this.tabCode,
      sdate: this.startDay,
      edate: this.endDay,
      pageNo: 1,
      pageSize: 10,
      personCount: this.adultNum + this.childNum
    }
    getHotelList(params).then(res => {
      this.loading = false
      console.log(res)
      if ((res && res.hotelList) || res.msg === '请求成功') {
        this.hotListData = res.hotelList || []
      } else {
        this.$message.error(res.msg)
      }
    }).catch(err => {
      console.error(err)
    })
  }

  mounted () {
    this.startWeek = this.weekList[new Date(this.startDay).getDay()]
    this.endWeek = this.weekList[new Date(this.endDay).getDay()]
    // this.getHotelList() // 有城市code才能发起请求成功 所以放到了精品推荐城市接口内
    this.gerAdInfo() // 获取广告位
    this.getTuijianCity() // 获取精品推荐城市
  }
}
